import {
  ObalMaterialuNrSr as ObalMaterialuNrSrDto,
  ObalMaterialuNrSrApi,
  ObalMaterialuNrSrUpdate,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import {
  ObalMaterialuNrSr,
} from '../../../model/sprievodnyDokument/obalMaterialu/ObalMaterialuNrSr';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';

const client = new ObalMaterialuNrSrApi(apiConfiguration(evidenciaPrefixPath));

function mapToObalDto(obalNrSr: ObalMaterialuNrSr): ObalMaterialuNrSrDto {
  return {
    rezortneCislo: obalNrSr.rezortneCislo,
    cisloParlamentnejTlace: obalNrSr.cisloParlamentnejTlace,
    vladnyNavrh: obalNrSr.vladnyNavrh,
    typMaterialu: obalNrSr.typMaterialu,
    nazovMaterialu: obalNrSr.nazovMaterialu,
    navrhUznesenia: obalNrSr.navrhUznesenia,
    predkladatel: obalNrSr.predkladatel,
    miestoDatum: obalNrSr.miestoDatum,
  };
}

function mapToObalUpdateRequest(sprievodnyDokumentUuid: Uuid, obalNrSr: ObalMaterialuNrSr): ObalMaterialuNrSrUpdate {
  return {
    sprievodnyDokumentUuid,
    obalMaterialu: mapToObalDto(obalNrSr),
  };
}

export const createObalMaterialuNrSrClient = async (
  legMaterialUuid: Uuid,
  obalMaterialuNrSr: ObalMaterialuNrSr,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.createObalMaterialuNrSr(legMaterialUuid, mapToObalDto(obalMaterialuNrSr), stadiumUuid, headers);

  return {
    responseCode: status,
  };
};

export const updateObalMaterialuNrSrClient = async (
  legMaterialUuid: Uuid,
  obalMaterialuNrsr: ObalMaterialuNrSr,
  sprievodnyDokumentUuid: Uuid,
  stadiumUuid?: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.updateObalMaterialuNrSr(
    legMaterialUuid,
    mapToObalUpdateRequest(sprievodnyDokumentUuid, obalMaterialuNrsr),
    stadiumUuid,
    headers,
  );

  return {
    responseCode: status,
  };
};
